export default __webpack_public_path__ + "static/media/ScanAsset.9e97efd3.svg";